interface CounterProps {
  value: number
  min: number
  max: number
  onChange: (value: number) => void
  label?: string
  className?: string
}

export function Counter({ value, min, max, onChange, label, className = '' }: CounterProps) {
  const handleClick = () => {
    if (value < max) {
      onChange(value + 1)
    } else {
      onChange(min)
    }
  }

  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <button
        type="button"
        onClick={handleClick}
        className="w-10 h-10 rounded bg-yellow-400 hover:bg-yellow-500 text-white font-bold flex items-center justify-center transition-colors text-lg"
      >
        {value}
      </button>
      {label && <span className="text-xs text-gray-600 dark:text-gray-400 font-medium">{label}</span>}
    </div>
  )
}
